import { GoogleSignInButton } from "@/components/GoogleSignInButton";
import { PhoneSignInButton } from "@/components/PhoneSignInButton";
import { View } from "react-native";

interface SocialSignInRowProps {
  onGooglePress: () => void;
  onPhonePress: () => void;
  disabled?: boolean;
  // Overrides the default `SIGN_UP_WITH_PHONE` label.
  phoneLabelKey?: string;
}

export function SocialSignInRow({
  onGooglePress,
  onPhonePress,
  disabled,
  phoneLabelKey = "SIGN_UP_WITH_PHONE",
}: SocialSignInRowProps) {
  return (
    <View style={{ flexDirection: "row", justifyContent: "center", gap: 16 }}>
      <GoogleSignInButton onPress={onGooglePress} disabled={disabled} square />
      <PhoneSignInButton
        onPress={onPhonePress}
        disabled={disabled}
        labelKey={phoneLabelKey}
        square
      />
    </View>
  );
}
